class Timer {
  constructor(callback, timeout, is_interval = false) {
    this.callback = callback;
    this.timeout = timeout;
    this.is_interval = is_interval;
    this._timer = is_interval
      ? setInterval(this.callback, this.timeout)
      : setTimeout(this.callback, this.timeout);
  }
  destroy() {
    if (this._timer) {
      this.is_interval ? clearInterval(this._timer) : clearTimeout(this._timer);
      this._timer = null;
    }
  }
}
export default Timer;
